import type { RouteObject } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Home from '@/pages/home/page';
import ForexBasics from '@/pages/forex-basics/page';
import ForexTrading from '@/pages/forex-trading/page';
import Mt4Mt5 from '@/pages/mt4-mt5/page';
import ForexAnalysis from '@/pages/forex-analysis/page';
import RiskManagement from '@/pages/risk-management/page';
import Glossary from '@/pages/glossary/page';
import ArticlePage from '@/pages/article/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'forex-basics', element: <ForexBasics /> },
      { path: 'forex-trading', element: <ForexTrading /> },
      { path: 'mt4-mt5', element: <Mt4Mt5 /> },
      { path: 'forex-analysis', element: <ForexAnalysis /> },
      { path: 'risk-management', element: <RiskManagement /> },
      { path: 'glossary', element: <Glossary /> },
      { path: ':slug', element: <ArticlePage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;